// #region Imports
import { defineComponent, h } from "vue";
// #endregion
// #region Core
export default defineComponent({
    //#region Vars
    name: 'g-dynamic-html',
    // #endregion
    // #region Properties
    props: {
        template: String,
        parent: Object,
        templateProps: {
            type: Object,
            default: () => ({})
        }
    },
    //#endregion
    // #region Render
    render() {
        // #region Prepare
        const parent = this.parent || this.$parent;
        const { $data: parentData = {}, $props: parentProps = {}, $options: parentOptions = {} } = parent;
        const { components: parentComponents = {}, computed: parentComputed = {}, methods: parentMethods = {} } = parentOptions;
        const { $data = {}, $props = {}, $options: { methods = {}, computed = {}, components = {} } = {} } = this;
        const passthrough = {
            $data: {},
            $props: {},
            $options: {},
            components: {},
            computed: {},
            methods: {}
        };
        // #endregion
        // #region Values
        //build new objects by removing keys if already exists (e.g. created by mixins)
        Object.keys(parentData).forEach((e) => {
            if (typeof $data[e] === "undefined")
                passthrough.$data[e] = parentData[e];
        });
        Object.keys(parentProps).forEach((e) => {
            if (typeof $props[e] === "undefined")
                passthrough.$props[e] = parentProps[e];
        });
        Object.keys(parentMethods).forEach((e) => {
            if (typeof methods[e] === "undefined")
                passthrough.methods[e] = parentMethods[e];
        });
        Object.keys(parentComputed).forEach((e) => {
            if (typeof computed[e] === "undefined")
                passthrough.computed[e] = parentComputed[e];
        });
        Object.keys(parentComponents).forEach((e) => {
            if (typeof components[e] === "undefined")
                passthrough.components[e] = parentComponents[e];
        });
        //Simple
        const methodKeys = Object.keys(passthrough.methods || {});
        const dataKeys = Object.keys(passthrough.$data || {});
        const propKeys = Object.keys(passthrough.$props || {});
        const templatePropKeys = Object.keys(this.templateProps);
        const allKeys = dataKeys.concat(propKeys).concat(methodKeys).concat(templatePropKeys);
        const methodsFromProps = utils.buildFromProps(parent, methodKeys);
        //Merge
        const finalProps = utils.mergeObject([
            passthrough.$data,
            passthrough.$props,
            methodsFromProps,
            this.templateProps
        ]);
        const provide = this.$parent?._provided;
        // #endregion            
        // #region Final
        const component = {
            template: this.template || "<div></div>",
            props: allKeys,
            computed: passthrough.computed,
            components: passthrough.components,
            provide: provide,
            inheritAttrs: false
        };
        return h(component, finalProps);
        // #endregion
    },
    // #endregion
});
// #endregion
